<template>
    <div>
        <v-row class="ma-n4">
            <template v-for="item in interviewers">
                <v-col cols="12" class="pa-4" :key="item._id">
                    <room-participants-item v-bind="{ item }" isItemInterviewer />
                </v-col>
            </template>
            <template v-for="item in interviewees">
                <v-col cols="12" class="pa-4" :key="item._id">
                    <room-participants-item v-bind="{ item }" />
                </v-col>
            </template>
            <v-col cols="12" class="pa-4" v-if="isUserInterviewer">
                <room-participants-push>
                    <template #activator="{ attrs, on }">
                        <v-card flat color="grey lighten-5" class="pa-8 d-flex justify-center" v-bind="attrs" v-on="on">
                            <v-icon>mdi-plus-circle</v-icon>
                        </v-card>
                    </template>
                </room-participants-push>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { mapState } from "vuex";

import RoomParticipantsItem from "./room-participants-item.vue";
import RoomParticipantsPush from "./room-participants-push.vue";

export default {
    components: {
        RoomParticipantsItem,
        RoomParticipantsPush,
    },
    computed: {
        ...mapState("interview", { interview: (store) => store.data }),
        interviewers() {
            return this.interview.interviewers.sort((a, b) => a.name - b.name);
        },
        interviewees() {
            return [...this.interview.interviewees, ...this.interview.extraviewees].sort((a, b) => a.name - b.name);
        },
        isUserInterviewer() {
            return this.interview._company == this.$store.state.payload?._user;
        },
    },
};
</script>

<style>
</style>